import { STABLE_COINS } from '@vaultsfyi/common'

export function isStableCoin(symbol: string): boolean {
  return STABLE_COINS.includes(symbol)
}
